import { formatDistanceToNow } from 'date-fns';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SELF_SERVICE } from 'constants/ExtensionConstants';
import settings, { getEventField } from 'modules/notifications/data/settings';
import { tryParse } from 'utils/date';
import { bold, humanize } from 'utils/global';

import Iconography from '../Shared/Iconography';
import { StyledReference } from '../Shared/styles';
import { Content as ContentBase, SubContent, Extension } from '../Shared/UI';

/**
 * @type {React.FC<import('modules/notifications/types').Notification>}
 */
const SelfServiceAnswered = notification => {
  const intl = useIntl();

  const { createdOn: date, subType, extension } = notification;

  const extensionKey = extension.toLowerCase();
  const createdOn = React.useMemo(() => formatDistanceToNow(tryParse(date)), [date]);

  const eventField = getEventField(notification);
  const { linkReference, flatten, icon } = settings[SELF_SERVICE][eventField]?.ui(notification) ?? {};
  const { title } = linkReference ?? {};

  const isManualCheckout = subType === 'MANUAL_CHECK_OUT';

  return (
    <React.Fragment>
      <Iconography icon={icon} />
      <ContentBase>
        {isManualCheckout ? (
          <FormattedMessage
            id="notifications.card.SELF_SERVICE.SELF_SERVICE_ANSWERED_MANUAL_CHECK_OUT"
            defaultMessage="The manual check-out <b>was completed</b> for file {linkReference}"
            tagName="div"
            values={{
              b: bold,
              ...flatten,
              linkReference: <StyledReference>{title}</StyledReference>,
            }}
          />
        ) : (
          <FormattedMessage
            id="notifications.card.SELF_SERVICE.SELF_SERVICE_ANSWERED"
            defaultMessage="The customer completed the {selfServiceType} for file {linkReference}"
            tagName="div"
            values={{
              b: bold,
              ...flatten,
              linkReference: <StyledReference>{title}</StyledReference>,
              selfServiceType: intl
                .formatMessage({
                  id: `page.config.dealer_general.selfService.section.${subType}`,
                  defaultMessage: humanize(subType),
                })
                .toLowerCase(),
            }}
          />
        )}
        <SubContent>
          <Extension>
            <FormattedMessage id={`notifications.navigation.menu.${extensionKey}`} />
          </Extension>
          -
          <div>{createdOn}</div>
        </SubContent>

      </ContentBase>
    </React.Fragment>
  );
};

export default SelfServiceAnswered;
